function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useState } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { motion } from 'framer-motion';
import MobileMenuOverlay from './MobileMenuOverlay';
import NavBarHeader from './NavBarHeader';
import { useBreakpoint } from '../../hooks';
import { slowSpring } from '../../motion/transitions';
import ReactConfigContext from '../../ReactConfigContext';
export default function NavBar(param) {
    var hidden = param.hidden, items = param.items, action = param.action, metaItems = param.metaItems, searchAction = param.searchAction, homepageAction = param.homepageAction, languageOptions = param.languageOptions;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var _useBreakpoint = useBreakpoint(), maxWidth = _useBreakpoint.maxWidth, BREAKPOINTS = _useBreakpoint.BREAKPOINTS;
    var _useState = _sliced_to_array(useState(false), 2), menuOpen = _useState[0], setMenuOpen = _useState[1];
    var isTablet = !maxWidth || maxWidth < BREAKPOINTS.md;
    var handleToggleClick = function handleToggleClick() {
        setMenuOpen(!menuOpen);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("nav", null, !!(metaItems === null || metaItems === void 0 ? void 0 : metaItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "container pt-3 hidden md:block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end items-center"
    }, metaItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "meta-".concat(item.href)
        }, item), {
            className: twMerge('ml-7 text-navigation-small font-heading  font-semibold uppercase text-neutral-900/50', item.className)
        }));
    })))), /*#__PURE__*/ React.createElement(motion.nav, {
        key: "nav",
        className: "sticky top-0 left-0 z-10 bg-bg-base",
        initial: {
            y: '0%'
        },
        animate: {
            y: hidden ? '-100%' : '0%'
        },
        transition: slowSpring
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(NavBarHeader, {
        menuOpen: menuOpen,
        menuItems: items,
        action: action,
        homepageAction: homepageAction,
        searchAction: searchAction,
        languageOptions: languageOptions,
        onToggle: handleToggleClick
    }))), /*#__PURE__*/ React.createElement(MobileMenuOverlay, {
        open: menuOpen && isTablet,
        items: items,
        action: action,
        metaItems: metaItems,
        languageOptions: languageOptions,
        searchAction: searchAction,
        homepageAction: homepageAction,
        onToggle: handleToggleClick
    }));
}

//# sourceMappingURL=NavBar.js.map